// src/components/common/ErrorMessage.js
import React from 'react';
import { AlertCircle } from 'lucide-react';

const ErrorMessage = ({ message, className }) => {
  if (!message) return null;
  
  return (
    <div className={`p-4 rounded-md bg-red-50 border border-red-200 ${className || ''}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <p className="text-sm text-red-700">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;